import { render, staticRenderFns } from "./SkeletonPolicyFlexiblePathMeasureMenuTables.vue?vue&type=template&id=72b37781&"
import script from "./SkeletonPolicyFlexiblePathMeasureMenuTables.vue?vue&type=script&lang=js&"
export * from "./SkeletonPolicyFlexiblePathMeasureMenuTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports